import { createContext } from "react";
import { TeamReport } from "../../models/reports.agents";

export const TeamReportsContext = createContext<TeamReport[]>([]);
